"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeyDown = void 0;
var useKeyDown_1 = require("./useKeyDown");
Object.defineProperty(exports, "useKeyDown", { enumerable: true, get: function () { return __importDefault(useKeyDown_1).default; } });
